import gql from 'graphql-tag';

const GET_AUDIENCE_DEVICES = gql`
  query getAudienceDevices($audienceId: String!) {
    getAudienceDevices(audienceId: $audienceId)
  }
`;

export default GET_AUDIENCE_DEVICES;
